import classnames from 'classnames';
import { ButtonHTMLAttributes, HTMLAttributes, useMemo } from 'react';
import { PropsWithChildren } from 'react';

import './index.less';

interface Props extends Omit<HTMLAttributes<HTMLButtonElement>, 'type'> {
  type?: 'primary' | 'secondary';
  disabled?: boolean;
  htmlType?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}

const SZButton = (props: PropsWithChildren<Props>) => {
  const {
    className,
    htmlType = 'button',
    type = 'primary',
    disabled = false,
    ...rest
  } = props;

  const classNames = useMemo(() => {
    return classnames(
      {
        'sz-button': true,
        [`sz-button-${type}`]: true,
        [`sz-button-disabled`]: disabled,
      },
      className,
    );
  }, [className, type, disabled]);

  return (
    <button
      disabled={disabled}
      className={classNames}
      type={htmlType}
      {...rest}
    ></button>
  );
};

export default SZButton;
